export default __webpack_public_path__ + "static/radeema-00272a9cdda33c7a3fb68fd129cb6720.png";